/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { getLoggedUserGPID } from 'utils';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    CircularProgress,
    Tooltip,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import NotStartedIcon from '@mui/icons-material/NotStarted';
import { ErrorBoundary } from 'react-error-boundary';
import { Link, useHistory } from 'react-router-dom';
import ErrorFallback from 'components/error-fallback';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import axios from 'axios';
import { endPoints } from 'pages/dlops-dashboard/api/endpoint';
import { PEPVIGIL } from 'pages/dlops-dashboard/utils/constant';
import { commonStyles as styles } from 'assets/style';
import { Item, StyledTableHeader, StyledTableCell, style, componentStyles } from './style';
import { ProgressIcon } from '../style';
import stickyNotes from '../../../assets/images/dlopsImages/sticky-note-solid.svg';
import TraiangleExclamation from '../../../assets/images/dlopsImages/triangle-exclamation-solid.svg';
import AccessToken from '../components/accessToken/accessToken';
import breadcrumbIcon from '../../../assets/images/dlopsImages/arrow_forward.svg';
import TableComponent from './driftMetricTable';
import ClusterDetailsTable from './clusterDetailsTable';

const DlopsModels = () => {
    const colorCodes = { green500: '#008553', yellow500: '#FFBF1C' };
    const { getAccessToken, handleTokenError } = AccessToken();
    // const [columnNamePrediction, setColumnNamePrediction] = useState('');
    const [isLoading, setLoading] = useState(true);
    const history = useHistory();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [value, setValue] = React.useState('1');
    const [activeModelData, setActiveModelData] = useState([]);
    const [conditionalModel, setConditionalModel] = useState(false);
    const [driftColumnStatus, setDriftColumnStatus] = useState(false);
    const [activeModelConditionalData, setActiveModelConditionalData] = useState({});
    const [archivedThresholdMetric, setArchivedThresholdMetric] = useState('');
    const [conditionalArchivedModel, setconditionalArchivedModel] = useState(false);
    const [nonActiveModel, setNonActiveModel] = useState([]);
    const [newModelData, setNewModelData] = useState([]);
    const [predictionModelMetricThreshold, setPredictionModelMetricThreshold] = useState('');
    const [open, setOpen] = useState(false);
    const [getBaselineStatus, setBaselineStatus] = useState(null);
    const [driftBaseline, setDriftBaseline] = useState([]);
    const [moduleID, setModuleID] = useState('');
    const [smartSamplingStatusDetails, setSmartSamplingStatusDetails] = useState({ status: null, completed_at: null });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const conditionalModelColumns = [
        {
            name: 'Avg. confidence score',
        },
        {
            name: 'Avg. drift distance',
        },
        {
            name: 'Data Drift Index (PSI)',
        },
    ];

    const driftedDatasetColumn = [
        {
            name: 'Drifted dataset',
            maxWidth: '130px',
        },
    ];

    const activeColumns = [
        {
            name: 'Model',
        },
        ...(getBaselineStatus !== 'success' ? [{ name: 'Action' }] : []),
        {
            name: 'Version',
        },
        { name: 'Stage' },
        { name: 'Type' },
        {
            name: 'Framework',
        },
        // { name: 'Data source version' },
        ...(conditionalModel ? conditionalModelColumns : []),
        ...(driftColumnStatus ? driftedDatasetColumn : []),
    ];

    const nonActivecolumns = [
        {
            name: 'Model',
        },
        {
            name: 'Version',
        },
        { name: 'Stage' },
        { name: 'Type' },
        {
            name: 'Framework',
        },
        { name: 'Data source version' },
        ...(conditionalArchivedModel ? conditionalModelColumns : []),
    ];
    const newModelColumns = [
        {
            name: 'Model',
        },
        {
            name: 'Version',
        },
        { name: 'Stage' },
        { name: 'Type' },
        {
            name: 'Framework',
        },
        { name: 'Data source version' },
    ];

    const updateNewModelData = (modelName, sortByVersionData) => {
        const filterByModelName = sortByVersionData.filter((model) => model.name === modelName);
        const groupedData = filterByModelName.reduce((groups, item) => {
            if (item.current_stage === 'None') {
                if (!groups[item.name] || parseInt(item.version, 10) > parseInt(groups[item.name].version, 10)) {
                    // eslint-disable-next-line no-param-reassign
                    groups[item.name] = item;
                }
            }
            return groups;
        }, {});

        // Convert the grouped data back into an array
        const latestNoneVersions = Object.values(groupedData);
        setNewModelData(latestNoneVersions);
    };

    const getModelOnboardedMetrics = (filterActiveModel) => {
        const modelMetricsTag = filterActiveModel[0].tags.find((tag) => tag.key === 'model_metrics');
        const extractedValues = {};
        if (modelMetricsTag) {
            const modelMetricsValue = modelMetricsTag.value;
            let modelMetrics;
            try {
                modelMetrics = JSON.parse(modelMetricsValue.replace(/'/g, '"'));
            } catch (error) {
                const metricsArray = modelMetricsValue.split(',');
                metricsArray.forEach((metric) => {
                    const trimmedMetric = metric.trim();
                    const metricTag = filterActiveModel[0].tags.find((tag) => tag.key === trimmedMetric);
                    if (metricTag) {
                        extractedValues[trimmedMetric] = parseFloat(metricTag.value);
                    }
                });
            }
            if (Array.isArray(modelMetrics) && modelMetrics.includes('accuracy')) {
                const accuracyTag = filterActiveModel[0].tags.find((tag) => tag.key === 'accuracy');
                if (accuracyTag) {
                    let accuracyValues;
                    try {
                        accuracyValues = JSON.parse(accuracyTag.value);
                        if (Array.isArray(accuracyValues)) {
                            extractedValues.accuracy = parseFloat(accuracyValues[1]);
                        } else {
                            extractedValues.accuracy = 0.75;
                        }
                    } catch (error) {
                        extractedValues.accuracy = 0.75;
                    }
                } else {
                    extractedValues.accuracy = 0.75;
                }
            } else {
                extractedValues.accuracy = 0.75;
            }
        }
        const formattedValues = Object.keys(extractedValues).map((key) => ({
            key: 'accuracy',
            value: extractedValues[key],
        }));
        return formattedValues;
    };

    const getDriftAccuracy = async (filterActiveModel) => {
        const runIds = filterActiveModel.map((item) => item.run_id || item.model_id);
        const modelVersionStorage = localStorage.getItem('modelVersionsCheck');
        let accuracyThreshold;
        if (modelVersionStorage === false) {
            accuracyThreshold = filterActiveModel[0].tags.find((tag) => tag.key === 'model_metric_threshold');
        } else {
            accuracyThreshold = getModelOnboardedMetrics(filterActiveModel);
        }
        const payload = { model_id: runIds[0] };
        setPredictionModelMetricThreshold(accuracyThreshold);
        try {
            const accessToken = await getAccessToken();
            const response = await axios.post(endPoints.accuracyDistanceForActiveModel, payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.data.status === 'success') {
                if (Object.keys(response?.data?.data).length !== 0 && response?.data?.data !== 'None') {
                    setConditionalModel(true);
                    setActiveModelConditionalData(response?.data?.data);
                    const data = response?.data?.data;
                    const currentPrediction = parseFloat(data?.PredictionAccuracy?.currentMetricValue);
                    // const thresholdPrediction = data?.PredictionAccuracy?.threshold;
                    // let thresholdPrediction = accuracyThreshold ? accuracyThreshold.value : data?.PredictionAccuracy?.autoThre;
                    let thresholdPrediction;
                    if (accuracyThreshold && Array.isArray(accuracyThreshold)) {
                        thresholdPrediction = parseFloat(accuracyThreshold[0].value);
                    } else if (accuracyThreshold) {
                        thresholdPrediction = parseFloat(accuracyThreshold.value);
                    } else {
                        thresholdPrediction = data?.PredictionAccuracy?.autoThre;
                    }
                    thresholdPrediction = parseFloat(thresholdPrediction);
                    const currentEuclidean = parseFloat(data?.EuclideanDistance?.currentMetricValue);
                    const thresholdEuclidean = data?.EuclideanDistance?.user_threshold;

                    const prediction = currentPrediction <= thresholdPrediction;
                    const euclidean = currentEuclidean < thresholdEuclidean;
                    const allNoData =
                        data?.PredictionAccuracy?.currentMetricValue === 'No data' &&
                        data?.PredictionAccuracy?.user_threshold === 'No data' &&
                        data?.psiPrediction?.currentMetricValue === 'No data' &&
                        data?.psiPrediction?.threshold === 'No data';

                    if (allNoData) {
                        setDriftColumnStatus(false);
                    } else if (prediction === true && euclidean === true) {
                        setDriftColumnStatus(false);
                    } else if (prediction === false && euclidean === true) {
                        setDriftColumnStatus(true);
                    } else if (prediction === false && euclidean === false) {
                        setDriftColumnStatus(true);
                    } else if (prediction === true && euclidean === false) {
                        setDriftColumnStatus(true);
                    }
                }
            }

            return response.data;
        } catch (error) {
            return handleTokenError(error, endPoints.accuracyDistanceForActiveModel, 'post', payload);
        }
    };
    const getDriftData = async (filterActiveModel) => {
        const runIds = filterActiveModel.map((item) => item.run_id || item.model_id);
        const payload = { model_id: runIds[0] };
        setModuleID(payload);
        setLoading(true);
        try {
            const accessToken = await getAccessToken();
            const response = await axios.post(endPoints.driftMonitorMetrics, payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setDriftBaseline(response?.data?.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            handleTokenError(error, endPoints.driftMonitorMetrics, 'post', payload);
        }
    };
    const updateDriftAccuracyValue = (latestNoneVersions, driftAccuracy) => {
        try {
            const accuracyMapping = driftAccuracy?.data;

            if (accuracyMapping) {
                const updatedModelData = latestNoneVersions.map((model) => {
                    // If accuracyInfo is available, update the model object
                    return {
                        ...model,
                        EuclideanDistance: accuracyMapping.EuclideanDistance,
                        PredictionAccuracy: accuracyMapping.PredictionAccuracy,
                    };
                });
                return updatedModelData;
            }
            const updatedOriginalData = latestNoneVersions.map((model) => ({
                ...model,
                EuclideanDistance: undefined,
                PredictionAccuracy: undefined,
            }));

            return updatedOriginalData;
        } catch (error) {
            // Handle the error here, e.g., log it or return a default value
            return error;
        }
    };
    const fetchObservabilityModel = async (runId, accessToken) => {
        try {
            const response = await axios.get(endPoints.testObserveModelEndPoint(runId), {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response?.data;
        } catch (error) {
            return handleTokenError(error, endPoints.testObserveModelEndPoint(runId), 'get', null);
        }
    };

    const fetchIngestionDetails = async (retainingData) => {
        if (retainingData && retainingData?.model_type?.toLowerCase() === 'segmentation') {
            try {
                const accessToken = await getAccessToken();
                const response = await axios
                    .get(endPoints.getSmartSamplingAutomatedIngestionStatusDetails, {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                        params: {
                            project_name: retainingData?.project_name,
                            model_name: retainingData?.model_name,
                            model_version: retainingData?.model_version,
                        },
                    })
                    .then((res) => res.data);

                setSmartSamplingStatusDetails({
                    status: response?.data?.latest_run?.status ?? null,
                    completed_at: response?.data?.latest_run?.completed_at ?? null,
                });
            } catch (error) {
                setSmartSamplingStatusDetails({
                    status: null,
                    completed_at: null,
                });
            }
        }
    };

    const getObservabilityModel = async (latestActiveVersion) => {
        const runId = latestActiveVersion.map((item) => item.run_id || item.model_id);
        localStorage.setItem('retraining_data', JSON.stringify([]));
        try {
            const accessToken = await getAccessToken();
            const response = await fetchObservabilityModel(runId, accessToken);
            const baselineStatus = response?.data?.model?.baseline_ingestion_status?.toLowerCase();
            if (response?.status === 'success') {
                localStorage.setItem('retraining_data', JSON.stringify(response?.data?.model));
                fetchIngestionDetails(response?.data?.model);
                // Set baseline status to 'not started' or 'failed' if conditions are met
                setBaselineStatus(baselineStatus);
            } else {
                // Clear baselineStatus if API call is successful but conditions aren't met
                setBaselineStatus('');
            }
        } catch (error) {
            // if (error?.response?.status === 404 && error?.response?.data?.message.includes('No model with this model_id')) {
            //     // Enable the Edit button if error is 404 and message contains "No model with this model_id"
            //     setEnableEditButton(true);
            // } else {
            //     // Disable the Edit button in case of other errors
            //     setEnableEditButton(false);
            // }
            setBaselineStatus('');
        }
    };

    const driftData = (modelName, sortByVersionData) => {
        // const filterActiveModel = sortByVersionData.filter((item) => item.current_stage === 'Production');
        const filterByModelName = sortByVersionData.filter((model) => model.name === modelName);
        const filteredData = filterByModelName.filter((item) => item.current_stage === 'Production');
        const sortByLatestVersions = filteredData.sort((a, b) => {
            const versionA = parseInt(a.version, 10);
            const versionB = parseInt(b.version, 10);
            return versionB - versionA;
        });
        const latestOneVersion = sortByLatestVersions.slice(0, 1);
        getDriftData(latestOneVersion);
    };

    const updateActiveModelData = (modelName, sortByVersionData) => {
        // const filterActiveModel = sortByVersionData.filter((item) => item.current_stage === 'Production');
        const filterByModelName = sortByVersionData.filter((model) => model.name === modelName);
        const filteredData = filterByModelName.filter((item) => item.current_stage === 'Production');
        const sortByLatestVersions = filteredData.sort((a, b) => {
            const versionA = parseInt(a.version, 10);
            const versionB = parseInt(b.version, 10);

            return versionB - versionA;
        });
        const latestOneVersion = sortByLatestVersions.slice(0, 1);
        getObservabilityModel(latestOneVersion);
        let driftAccuracy;
        if (latestOneVersion.length > 0) {
            try {
                driftAccuracy = getDriftAccuracy(latestOneVersion);
            } catch (accuracyError) {
                return accuracyError;
            }
        }
        const updatedDriftData = updateDriftAccuracyValue(latestOneVersion, driftAccuracy);
        return setActiveModelData(updatedDriftData);
    };

    const getModelData = async (modelName, gpid) => {
        try {
            const accessToken = await getAccessToken();

            const response = await axios.get(endPoints.registeredModelVersions(modelName), {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    gpid,
                },
            });
            return response.data;
        } catch (error) {
            return handleTokenError(error, endPoints.registeredModelVersions(modelName), 'get', null);
        }
    };

    function removeMatchingObjects(dataArray, comparisonArray) {
        return dataArray.filter((dataItem) => {
            const matchingItem = comparisonArray.find(
                (comparisonItem) => comparisonItem.version === dataItem.version && comparisonItem.current_stage === dataItem.current_stage
            );
            return !matchingItem;
        });
    }

    const findThresholdForMlFlow = (data) => {
        const thresholdValuesWithRunId = data
            .map((item) => {
                const runId = item.run_id;

                return (item.tags || []).filter((tag) => tag.key === 'model_metric_threshold').map((tag) => ({ runId, key: tag.key, value: tag.value }));
            })
            .flat();
        return thresholdValuesWithRunId;
    };

    const parseValue = (accuracyValue) => {
        try {
            const parsedValue = JSON.parse(accuracyValue.replace(/'/g, '"'));
            if (Array.isArray(parsedValue)) {
                return parsedValue.length > 1 ? parseFloat(parsedValue[1]) : parseFloat(parsedValue[0]);
            }
            if (typeof parsedValue === 'string' && parsedValue.includes(',')) {
                const splitValues = parsedValue.split(',').map((val) => val.trim());
                return parseFloat(splitValues[1] || splitValues[0]);
            }
            return parseFloat(parsedValue);
        } catch (error) {
            // If parsing fails and the value is a comma-separated string
            if (typeof accuracyValue === 'string' && accuracyValue.includes(',')) {
                const splitValues = accuracyValue.split(',').map((val) => val.trim());
                return parseFloat(splitValues[1] || splitValues[0]);
            }
            // Return the value directly if no special handling is needed
            return parseFloat(accuracyValue);
        }
    };

    const findThresholdForUIOnboarded = (data) => {
        const thresholdValuesWithRunId = data.map((item) => {
            const runId = item.model_id;
            const modelMetricsTag = (item.tags || []).find((tag) => tag.key === 'model_metrics');

            let thresholdValue = null;
            if (modelMetricsTag) {
                const modelMetricsValue = modelMetricsTag.value;
                let modelMetrics;
                try {
                    modelMetrics = JSON.parse(modelMetricsValue.replace(/'/g, '"'));
                } catch (error) {
                    // Handle parsing error if needed
                }
                if (Array.isArray(modelMetrics) && modelMetrics.includes('accuracy')) {
                    const accuracyTag = (item.tags || []).find((tag) => tag.key === 'accuracy');
                    if (accuracyTag) {
                        thresholdValue = parseValue(accuracyTag.value);
                    }
                }
            }
            return { runId, key: 'accuracy', value: thresholdValue || 0.75 };
        });
        return thresholdValuesWithRunId;
    };

    const getAccuracyArchiveDistance = async (filterNonActiveModel) => {
        const runIds = filterNonActiveModel.map((item) => item.run_id || item.model_id);
        const modelVersionStorage = localStorage.getItem('modelVersionsCheck');
        let accuracyThreshold;
        if (modelVersionStorage === false) {
            accuracyThreshold = findThresholdForMlFlow(filterNonActiveModel);
        } else {
            accuracyThreshold = findThresholdForUIOnboarded(filterNonActiveModel);
        }

        setArchivedThresholdMetric(accuracyThreshold);
        const payload = { model_ids: runIds };
        try {
            const accessToken = await getAccessToken();
            const response = await axios.post(endPoints.accuracyDistanceForNonActiveModel, payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response?.data?.status === 'success') {
                if (Array.isArray(response?.data?.data) && response?.data?.data.length > 0) {
                    response.data.data.forEach((dataItem) => {
                        // const modelId = dataItem.model_id;
                        const driftMetrics = dataItem.drift_metrics;
                        if (
                            driftMetrics.PredictionAccuracy.currentMetricValue !== 'No data' ||
                            driftMetrics.EuclideanDistance.currentMetricValue !== 'No data'
                        ) {
                            setconditionalArchivedModel(true);
                        }
                    });
                }
            }

            return response?.data?.data;
        } catch (error) {
            return handleTokenError(error, endPoints.accuracyDistanceForNonActiveModel, 'post', payload);
        }
    };

    const driftAccuracyArchived = (latestNoneVersion, driftAccuracyArray) => {
        try {
            if (driftAccuracyArray && driftAccuracyArray.length > 0) {
                const mergedData = latestNoneVersion.map((model) => {
                    // Find the matching driftAccuracy object based on model_id
                    const driftAccuracy = driftAccuracyArray.find((accuracy) => accuracy.model_id === (model.run_id || model.model_id));
                    if (driftAccuracy) {
                        const currentPredictionValue = driftAccuracy?.drift_metrics?.PredictionAccuracy?.currentMetricValue;

                        let currentPrediction;
                        if (currentPredictionValue !== 'No data') {
                            currentPrediction = parseFloat(currentPredictionValue);

                            // eslint-disable-next-line no-restricted-globals
                            if (isNaN(currentPrediction)) {
                                currentPrediction = 0;
                            }
                        } else {
                            currentPrediction = 0;
                        }
                        return {
                            ...model,
                            PredictionAccuracy: driftAccuracy.drift_metrics.PredictionAccuracy,
                            EuclideanDistance: driftAccuracy.drift_metrics.EuclideanDistance,
                        };
                    }
                    return {
                        ...model,
                        EuclideanDistance: undefined,
                        PredictionAccuracy: undefined,
                    };
                });
                return mergedData;
            }
            const updatedOriginalData = latestNoneVersion.map((model) => ({
                ...model,
                EuclideanDistance: undefined,
                PredictionAccuracy: undefined,
            }));
            return updatedOriginalData;
        } catch (error) {
            return error;
        }
    };
    // eslint-disable-next-line consistent-return
    const updateNonActiveModelData = async (modelName, sortByVersionData) => {
        const filterByModelName = sortByVersionData.filter((model) => model.name === modelName);
        const filteredModels = filterByModelName.filter((model) => model.current_stage === 'Archived' || model.current_stage === 'None');
        const groupedData = filteredModels.reduce((groups, item) => {
            if (item.current_stage === 'None') {
                if (!groups[item.name] || parseInt(item.version, 10) > parseInt(groups[item.name].version, 10)) {
                    // eslint-disable-next-line no-param-reassign
                    groups[item.name] = item;
                }
            }
            return groups;
        }, {});

        // Convert the grouped data back into an array
        const latestNoneVersions = Object.values(groupedData);
        const filteredremoveMatchingObjects = removeMatchingObjects(filteredModels, latestNoneVersions);
        const sortByLatestVersion = filteredremoveMatchingObjects.sort((a, b) => {
            const versionA = parseInt(a.version, 10);
            const versionB = parseInt(b.version, 10);

            return versionB - versionA;
        });
        let driftAccuracy;
        if (sortByLatestVersion.length > 0) {
            try {
                driftAccuracy = await getAccuracyArchiveDistance(sortByLatestVersion);
            } catch (accuracyError) {
                return accuracyError;
            }
        }

        const updatedDriftData = driftAccuracyArchived(sortByLatestVersion, driftAccuracy);

        //  const firstThreeRecord = sortByLatestVersion.slice(0, 3);
        setNonActiveModel(updatedDriftData);
    };

    const getRegisteredDlopsModelVersion = async (accessTokenPromise, projectName) => {
        setLoading(true);
        try {
            const accessToken = await accessTokenPromise;
            const response = await axios.get(endPoints.registeredModelVersionsFromDlops(projectName), {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    Accept: 'application/json',
                },
            });
            setLoading(false);
            return response?.data;
        } catch (error) {
            setLoading(false);
            return error;
        }
    };

    // eslint-disable-next-line consistent-return
    const goToModelVersion = async () => {
        try {
            setLoading(true);
            const modelName = localStorage.getItem('modelName');
            const getProjectNameFromStorage = localStorage.getItem('project_name');
            const newAccessToken = localStorage.getItem('accessToken');
            const modelVersionStorage = localStorage.getItem('modelVersionsCheck');

            let response;
            let registeredModelResponse;
            let onBoardModelResponse;
            const gpid = getLoggedUserGPID();
            if (modelVersionStorage === 'false') {
                response = await getModelData(modelName, gpid);
                registeredModelResponse = response?.model_versions;
            } else {
                response = await getRegisteredDlopsModelVersion(newAccessToken, getProjectNameFromStorage);
                onBoardModelResponse = response;
            }
            const filterResponse = modelVersionStorage === 'false' ? registeredModelResponse : onBoardModelResponse;
            const filterByProject = filterResponse.filter((model) =>
                model?.tags?.some((tag) => tag.value.toLowerCase() === getProjectNameFromStorage.toLowerCase())
            );
            const filterByModelName = filterByProject.filter((mName) => mName.name === modelName);
            updateActiveModelData(modelName, filterByModelName);
            driftData(modelName, filterByModelName);
            updateNonActiveModelData(modelName, filterByModelName);
            updateNewModelData(modelName, filterByModelName);
            localStorage.setItem('modelnameByVersion', JSON.stringify(filterByModelName));

            setLoading(false);
        } catch (error) {
            setLoading(false);
            return error;
        }
    };

    const goToDashboard = (item) => {
        localStorage.setItem('modelDetails', JSON.stringify(item));
        localStorage.setItem('run_Id', item?.run_id || item?.model_id);
        history.push(`/pepvigil-model-observability?${item?.run_id} || ${item?.model_id}`);
    };

    useEffect(() => {
        goToModelVersion();
    }, []);

    const PredictionAccuracyContent = ({ isPredictionAccurate, currentValue }) => (
        <div style={{ display: 'flex', textAlign: 'center' }}>
            {currentValue !== 'No data' && (
                <span>
                    {isPredictionAccurate ? (
                        <Tooltip
                            title={<span style={{ fontSize: '1.2em' }}>Average prediction score is within a healthy range</span>}
                            componentsProps={{
                                tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                                arrow: { sx: { color: '#272727' } },
                            }}
                        >
                            <Typography
                                style={{
                                    width: '90px',
                                    borderRadius: '6px',
                                    background: `${colorCodes.green500} 0% 0% no-repeat padding-box`,
                                    opacity: 1,
                                    padding: '10px',
                                    textAlign: 'center',
                                    color: 'white',
                                }}
                            >
                                {currentValue !== 'No data' ? `${(parseFloat(currentValue) * 100).toFixed(0)}%` : 'No data'}
                            </Typography>
                        </Tooltip>
                    ) : (
                        <Tooltip
                            title={<span style={{ fontSize: '1.2em' }}>Average prediction score is outside the healthy range</span>}
                            componentsProps={{
                                tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                                arrow: { sx: { color: '#272727' } },
                            }}
                        >
                            <Typography
                                style={{
                                    width: '90px',
                                    borderRadius: '6px',
                                    background: `${colorCodes.yellow500} 0% 0% no-repeat padding-box`,
                                    opacity: 1,
                                    padding: '10px',
                                    textAlign: 'center',
                                }}
                            >
                                <img src={TraiangleExclamation} alt="warning icon" style={{ marginRight: '20px', textAlign: 'center' }} />
                                <span style={{ position: 'relative', right: '12px', bottom: '0px', fontSize: '14px' }}>
                                    {currentValue !== 'No data' ? `${(parseFloat(currentValue) * 100).toFixed(0)}%` : 'No data'}
                                </span>
                            </Typography>
                        </Tooltip>
                    )}
                </span>
            )}
        </div>
    );

    const conditionalNonActiveColumns = (row) => {
        const modelVersionStorage = localStorage.getItem('modelVersionsCheck');
        const currentPrediction = row?.PredictionAccuracy?.currentMetricValue;
        let thresholdPredictionObject;
        if (currentPrediction !== 'No data') {
            if (modelVersionStorage === false) {
                thresholdPredictionObject = archivedThresholdMetric.find(
                    (threshold) => threshold.runId === row.run_id && threshold.key === 'model_metric_threshold'
                );
            } else {
                thresholdPredictionObject = archivedThresholdMetric.find((threshold) => threshold.runId === row.model_id && threshold.key === 'accuracy');
            }
            let thresholdPrediction = parseFloat(row?.PredictionAccuracy?.user_threshold);
            if (Number.isNaN(thresholdPrediction)) {
                thresholdPrediction = parseFloat(thresholdPredictionObject?.value);
            }
            const isPredictionAccurate = parseFloat(currentPrediction) >= thresholdPrediction;

            return <PredictionAccuracyContent isPredictionAccurate={isPredictionAccurate} currentValue={currentPrediction} />;
        }
        return <div>No data</div>;
    };

    const conditionalEuclideanColumn = (row) => {
        const currentEuclidean = row?.EuclideanDistance?.currentMetricValue;

        // if (!currentEuclidean || currentEuclidean === 'No data') {
        //     return <div>No data</div>;
        // }

        const thresholdEuclidean = parseFloat(row?.EuclideanDistance?.user_threshold);
        const isEuclideanDistanceAccurate = currentEuclidean < thresholdEuclidean;
        if (currentEuclidean !== 'No data') {
            return (
                <div style={{ display: 'flex', textAlign: 'center' }}>
                    <span>
                        {isEuclideanDistanceAccurate ? (
                            <Tooltip
                                componentsProps={{
                                    tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                                    arrow: { sx: { color: '#272727' } },
                                }}
                                title={
                                    <span style={{ fontSize: '1.2em' }}>
                                        Average distance between image clusters of prediction and the training data is within a healthy range
                                    </span>
                                }
                            >
                                <Typography
                                    style={{
                                        width: '90px',
                                        borderRadius: '6px',
                                        background: `${colorCodes.green500} 0% 0% no-repeat padding-box`,
                                        opacity: 1,
                                        padding: '10px',
                                        textAlign: 'center',
                                        color: 'white',
                                    }}
                                >
                                    {currentEuclidean}
                                </Typography>
                            </Tooltip>
                        ) : (
                            <Tooltip
                                title={
                                    <span style={{ fontSize: '1.2em' }}>
                                        Average distance between image clusters of prediction and the training data is outside the healthy range
                                    </span>
                                }
                                componentsProps={{
                                    tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                                    arrow: { sx: { color: '#272727' } },
                                }}
                            >
                                <Typography
                                    style={{
                                        width: '90px',
                                        borderRadius: '6px',
                                        background: `${colorCodes.yellow500} 0% 0% no-repeat padding-box`,
                                        opacity: 1,
                                        padding: '10px',
                                        textAlign: 'center',
                                    }}
                                >
                                    <img src={TraiangleExclamation} alt="warning icon" style={{ marginRight: '20px', textAlign: 'center' }} />
                                    <span style={{ position: 'relative', right: '12px', bottom: '0px', fontSize: '14px' }}>{currentEuclidean}</span>
                                </Typography>
                            </Tooltip>
                        )}
                    </span>
                    {/* <span style={{ marginTop: '0px' }}>&nbsp;&nbsp;{currentEuclidean}</span> */}
                </div>
            );
        }

        return <div>No data</div>;
    };
    const handleNavigation = () => {
        history.push('/pepvigil-registered-models');
    };
    const handleShowDriftData = (row) => {
        localStorage.setItem('viewDriftDataSetVersion', JSON.stringify(row));
        history.push('/pepvigil-drift-images');
    };

    const conditionalProductionActiveColumns = () => {
        const currentPrediction = parseFloat(activeModelConditionalData?.PredictionAccuracy?.currentMetricValue);
        const multiplyPrediction = parseFloat(activeModelConditionalData?.PredictionAccuracy?.currentMetricValue) * 100;
        // const thresholdPrediction = parseFloat(predictionModelMetricThreshold.value);
        let thresholdPrediction = parseFloat(activeModelConditionalData?.PredictionAccuracy?.user_threshold);
        if (Number?.isNaN(thresholdPrediction)) {
            if (Array.isArray(predictionModelMetricThreshold) && predictionModelMetricThreshold.length > 0) {
                thresholdPrediction = parseFloat(predictionModelMetricThreshold?.[0]?.value);
            } else {
                thresholdPrediction = parseFloat(predictionModelMetricThreshold?.value);
            }
        }
        const isPredictionAccurate = currentPrediction >= thresholdPrediction;
        if (activeModelConditionalData?.PredictionAccuracy?.currentMetricValue === 'No data') {
            return 'N/A';
        }
        const icon = isPredictionAccurate ? (
            <Tooltip
                title={<span style={{ fontSize: '1.2em' }}>Average prediction score was within a healthy range</span>}
                componentsProps={{
                    tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                    arrow: { sx: { color: '#272727' } },
                }}
            >
                <Typography
                    style={{
                        width: '90px',
                        borderRadius: '6px',
                        background: `${colorCodes?.green500} 0% 0% no-repeat padding-box`,
                        opacity: 1,
                        textAlign: 'center',
                        padding: '10px',
                        color: 'white',
                    }}
                >
                    {activeModelConditionalData?.PredictionAccuracy?.currentMetricValue !== 'No data' ? `${multiplyPrediction.toFixed(0)}%` : 'No data'}
                </Typography>
            </Tooltip>
        ) : (
            <Tooltip
                title={<span style={{ fontSize: '1.2em' }}>Average prediction score was outside the healthy range</span>}
                componentsProps={{
                    tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                    arrow: { sx: { color: '#272727' } },
                }}
            >
                <Typography
                    style={{
                        width: '90px',
                        borderRadius: '6px',
                        background: `${colorCodes?.yellow500} 0% 0% no-repeat padding-box`,
                        opacity: 1,
                        padding: '10px',
                        textAlign: 'center',
                    }}
                >
                    <img src={TraiangleExclamation} alt="warning icon" style={{ marginRight: '20px', textAlign: 'center' }} />
                    <span style={{ position: 'relative', right: '12px', bottom: '0px', fontSize: '14px' }}>
                        {activeModelConditionalData?.PredictionAccuracy?.currentMetricValue !== 'No data' ? `${multiplyPrediction.toFixed(0)}%` : 'No data'}
                    </span>
                </Typography>
            </Tooltip>
        );

        return <Typography style={{ display: 'flex' }}>{icon}</Typography>;
    };

    const conditionalEuclideanActiveColumns = () => {
        const currentEuclidean = parseFloat(activeModelConditionalData?.EuclideanDistance?.currentMetricValue);
        const thresholdEuclidean = parseFloat(activeModelConditionalData?.EuclideanDistance?.user_threshold);
        const isEuclideanDistanceAccurate = currentEuclidean < thresholdEuclidean;
        if (activeModelConditionalData?.EuclideanDistance?.currentMetricValue === 'No Data') {
            return null;
        }
        const icon = isEuclideanDistanceAccurate ? (
            <Tooltip
                title={
                    <span style={{ fontSize: '1.2em' }}>
                        Average distance between image clusters of prediction and the training data was within a healthy range
                    </span>
                }
                componentsProps={{
                    tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                    arrow: { sx: { color: '#272727' } },
                }}
            >
                <Typography
                    style={{
                        width: '90px',
                        borderRadius: '6px',
                        background: `${colorCodes?.green500} 0% 0% no-repeat padding-box`,
                        opacity: 1,
                        padding: '10px',
                        textAlign: 'center',
                    }}
                >
                    <span style={{ color: 'white' }}>
                        {activeModelConditionalData?.EuclideanDistance?.currentMetricValue !== 'No data'
                            ? `${activeModelConditionalData?.EuclideanDistance?.currentMetricValue}`
                            : 'No data'}
                    </span>
                </Typography>
            </Tooltip>
        ) : (
            <Tooltip
                title={
                    <span style={{ fontSize: '1.2em' }}>
                        Average distance between image clusters of prediction and the training data was outside the healthy range
                    </span>
                }
                componentsProps={{
                    tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                    arrow: { sx: { color: '#272727' } },
                }}
            >
                <Typography
                    style={{
                        width: '90px',
                        borderRadius: '6px',
                        background: `${colorCodes?.yellow500} 0% 0% no-repeat padding-box`,
                        opacity: 1,
                        textAlign: 'center',
                        padding: '10px',
                    }}
                >
                    <img src={TraiangleExclamation} alt="warning icon" style={{ textAlign: 'center', marginRight: '20px' }} />
                    <span style={{ position: 'relative', right: '12px', bottom: '0px', fontSize: '14px' }}>
                        {activeModelConditionalData?.EuclideanDistance?.currentMetricValue !== 'No data'
                            ? `${activeModelConditionalData?.EuclideanDistance?.currentMetricValue}`
                            : 'No data'}
                    </span>
                </Typography>
            </Tooltip>
        );

        return (
            <div style={{ display: 'flex' }}>
                <div>{icon}</div>
            </div>
        );
    };

    const conditionalPSIPredictionActiveColumns = () => {
        const currentEuclidean = parseFloat(activeModelConditionalData?.psiPrediction?.currentMetricValue);
        const thresholdEuclidean = parseFloat(activeModelConditionalData?.psiPrediction?.threshold);
        const isEuclideanDistanceAccurate = currentEuclidean <= thresholdEuclidean;
        if (activeModelConditionalData?.psiPrediction?.currentMetricValue === 'No data') {
            return 'N/A';
        }
        const icon = isEuclideanDistanceAccurate ? (
            <Tooltip
                title={
                    <span style={{ fontSize: '1.2em' }}>
                        Average distance between image clusters of prediction and the training data was within a healthy range
                    </span>
                }
                componentsProps={{
                    tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                    arrow: { sx: { color: '#272727' } },
                }}
            >
                <Typography
                    style={{
                        width: '90px',
                        borderRadius: '6px',
                        background: `${colorCodes?.green500} 0% 0% no-repeat padding-box`,
                        opacity: 1,
                        padding: '10px',
                        textAlign: 'center',
                    }}
                >
                    <span style={{ color: 'white' }}>
                        {activeModelConditionalData?.psiPrediction?.currentMetricValue !== 'No data'
                            ? `${activeModelConditionalData?.psiPrediction?.currentMetricValue}`
                            : 'No data'}
                    </span>
                </Typography>
            </Tooltip>
        ) : (
            <Tooltip
                title={
                    <span style={{ fontSize: '1.2em' }}>
                        Average distance between image clusters of prediction and the training data was outside the healthy range
                    </span>
                }
                componentsProps={{
                    tooltip: { sx: { backgroundColor: '#272727', fontSize: '10px' } },
                    arrow: { sx: { color: '#272727' } },
                }}
            >
                <Typography
                    style={{
                        width: '90px',
                        borderRadius: '6px',
                        background: `${colorCodes?.yellow500} 0% 0% no-repeat padding-box`,
                        opacity: 1,
                        textAlign: 'center',
                        padding: '10px',
                    }}
                >
                    <img src={TraiangleExclamation} alt="warning icon" style={{ textAlign: 'center', marginRight: '20px' }} />
                    <span style={{ position: 'relative', right: '12px', bottom: '0px', fontSize: '14px' }}>
                        {activeModelConditionalData?.psiPrediction?.currentMetricValue !== 'No data'
                            ? `${activeModelConditionalData?.psiPrediction?.currentMetricValue}`
                            : 'No data'}
                    </span>
                </Typography>
            </Tooltip>
        );

        return (
            <div style={{ display: 'flex' }}>
                <div>{icon}</div>
            </div>
        );
    };
    const handleEdit = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleConfirmEdit = (activeModel) => {
        history.push('/pepvigil-edit-existing-model', {
            state: { activeData: activeModel[0] },
        });
        setOpen(false);
    };

    const getSamplingStatusLabel = (status) => {
        switch (status) {
            case 'in_progress':
                return 'Processing';
            case 'success':
                return 'Success';
            case 'partial_success':
                return 'Partial Success';
            case 'failed':
                return 'Failed';
            case 'timed_out':
                return 'Timed Out';
            case 'not_started':
                return 'Not Started';
            default:
                return 'Unknown';
        }
    };

    const getSamplingStatusLabelIconBasedOnStatus = (status) => {
        switch (status) {
            case 'in_progress':
                return <DonutLargeIcon sx={{ fontSize: '30px', color: '#005CBC' }} />;
            case 'success':
                return <CheckCircleIcon sx={{ fontSize: '30px', color: '#068c40' }} />;
            case 'partial_success':
                return <PublishedWithChangesIcon sx={{ fontSize: '30px', color: '#D6AC14' }} />;
            case 'failed':
                return <ReportProblemIcon sx={{ fontSize: '30px', color: '#C12C01' }} />;
            case 'timed_out':
                return <RunningWithErrorsIcon sx={{ fontSize: '30px', color: '#D6AC14' }} />;
            case 'not_started':
                return <NotStartedIcon sx={{ fontSize: '30px', color: '#a3a3a3' }} />;
            default:
                return null;
        }
    };

    const getSamplingStatusHeaderTextMessage = (status) => {
        switch (status) {
            case 'in_progress':
                return 'is being processed.';
            case 'success':
                return 'was processed successfully.';
            case 'partial_success':
                return 'was partially processed.';
            case 'failed':
                return 'failed to process.';
            case 'timed_out':
                return 'timed out during processing.';
            case 'not_started':
                return 'has not been started yet.';
            default:
                return '';
        }
    };

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Helmet>
                <title>{PEPVIGIL} Dashboard</title>
            </Helmet>
            <Box style={{ marginBottom: '20px' }}>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="h6">
                            <Item sx={style.subHeader}>
                                <div
                                    style={{
                                        // marginLeft: '28px',
                                        marginTop: '8px',
                                        fontSize: '14px',
                                        textAlign: 'left',
                                    }}
                                    className="contentContainer"
                                >
                                    <span>{PEPVIGIL}</span>
                                    <img src={breadcrumbIcon} alt=" bredcrumb" style={style.breadcrumbIcon} />
                                    <span aria-hidden="true" style={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={() => handleNavigation()}>
                                        Models
                                    </span>
                                    <img src={breadcrumbIcon} alt=" bredcrumb" style={style.breadcrumbIcon} />
                                    <span style={{ fontWeight: 'bold', color: '#005CBC' }}>Model versions</span>
                                </div>
                            </Item>
                        </Typography>
                    </Grid>
                </Grid>
                <Box className="contentContainer">
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{
                            sx: {
                                width: '500px',
                                // height: '200px',
                                // maxHeight: '50vh',
                            },
                        }}
                    >
                        <Box
                            sx={{
                                ...styles.modalWrapper,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <DialogTitle sx={styles.modalTitle}>Edit Model</DialogTitle>
                            <DialogContent>
                                <DialogContentText sx={styles.modalContent}>Do you want to edit model?</DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    // variant="outlined"
                                    onClick={handleClose}
                                    // color="primary"
                                    sx={{ ...styles.modalCancelButton }}
                                >
                                    No
                                </Button>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    disableRipple
                                    onClick={() => handleConfirmEdit(activeModelData)}
                                    // color="primary"
                                    sx={styles.modalSaveButton}
                                >
                                    Yes
                                </Button>
                            </DialogActions>
                        </Box>
                    </Dialog>
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100vh' }}>
                            <CircularProgress color="inherit" size={16} sx={ProgressIcon.circularProgressColor} />
                            <Typography variant="body2" sx={ProgressIcon.circularProgressColor} style={{ marginLeft: '10px' }}>
                                Loading
                            </Typography>
                        </Box>
                    ) : (
                        <>
                            {smartSamplingStatusDetails?.status && (
                                <Box sx={{ marginTop: '25px' }}>
                                    <div style={style.notificationWrapper}>
                                        {/* left side icon and text */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            {getSamplingStatusLabelIconBasedOnStatus(smartSamplingStatusDetails?.status)}
                                            <div>
                                                <div style={style.notificationHeaderTextStyle}>
                                                    Smart Sampling ingestion {getSamplingStatusHeaderTextMessage(smartSamplingStatusDetails?.status)}
                                                </div>
                                                <div style={style.notificationHeaderSubTextStyle}>
                                                    Lastest Hourly run
                                                    {smartSamplingStatusDetails?.status === 'in_progress'
                                                        ? ' is in progress'
                                                        : ` finished at ${new Date(`${smartSamplingStatusDetails.completed_at}`).toLocaleString('en-US', {
                                                              month: 'short',
                                                              day: 'numeric',
                                                              year: 'numeric',
                                                              hour: '2-digit',
                                                              minute: '2-digit',
                                                          })} UTC`}
                                                </div>
                                            </div>
                                        </div>
                                        {/* right side status */}
                                        <div
                                            style={{
                                                ...style.bannerStatus,
                                                ...style[`bannerStatus_${smartSamplingStatusDetails?.status}`],
                                            }}
                                        >
                                            {getSamplingStatusLabel(smartSamplingStatusDetails?.status)}
                                        </div>
                                    </div>
                                </Box>
                            )}
                            <div style={{ ...style.dataTable }}>
                                <div style={style.allProjectDiv}>
                                    <img src={stickyNotes} alt={stickyNotes} style={style.stickyNote} />
                                    <h5 style={style.projectText}>Models version ({activeModelData.length + nonActiveModel.length + newModelData.length})</h5>
                                </div>
                                <TabContext value={value}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider', marginLeft: '25px' }}>
                                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                                            <Tab disableRipple sx={style.tabStyle} label={`Active Models (${activeModelData.length})`} value="1" />
                                            <Tab disableRipple sx={style.tabStyle} label={`Non-Active Models (${nonActiveModel.length})`} value="2" />
                                            <Tab disableRipple sx={style.tabStyle} label={`New Models (${newModelData.length})`} value="3" />
                                        </TabList>
                                    </Box>
                                    <TabPanel value="1">
                                        {activeModelData.length <= 0 ? (
                                            <Typography variant="body1" style={{ textAlign: 'center', marginTop: '20px' }}>
                                                No Records to display for active Model
                                            </Typography>
                                        ) : (
                                            <TableContainer component={Paper}>
                                                <Table>
                                                    <TableHead sx={{ backgroundColor: (theme) => theme.palette.cyan['90'] }}>
                                                        <TableRow>
                                                            {activeColumns.map((column, index) => (
                                                                <StyledTableHeader key={index} maxWidth={column.maxWidth}>
                                                                    {column.name}
                                                                </StyledTableHeader>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {activeModelData?.map((row, index1) => (
                                                            <TableRow key={index1}>
                                                                <StyledTableCell sx={{ color: '#005CBC', fontWeight: 'normal' }}>
                                                                    <Link
                                                                        to="/pepvigil-model-observability"
                                                                        onClick={() => goToDashboard(row)}
                                                                        className="router-link"
                                                                        style={{ color: '#005CBC' }}
                                                                    >
                                                                        {row.name}
                                                                    </Link>
                                                                </StyledTableCell>
                                                                {getBaselineStatus !== 'success' && (
                                                                    <StyledTableCell sx={{ color: '#000000', fontWeight: 'normal' }}>
                                                                        <Button
                                                                            variant="contained"
                                                                            onClick={handleEdit}
                                                                            disableElevation
                                                                            disableRipple
                                                                            // sx={{
                                                                            //     backgroundColor: '#1378D4',
                                                                            //     '&:hover': {
                                                                            //         backgroundColor: '#125c99',
                                                                            //     },
                                                                            // }}
                                                                            sx={styles.serviceTagBtn}
                                                                        >
                                                                            Edit
                                                                        </Button>
                                                                    </StyledTableCell>
                                                                )}

                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>{row?.version}</StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>{row?.current_stage}</StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>
                                                                    {row?.tags.find((tag) => tag.key === 'model_type')?.value || 'undefined'}
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>
                                                                    {row?.tags.find((tag) => tag.key === 'framework')?.value || 'undefined'}
                                                                </StyledTableCell>
                                                                {/* <StyledTableCell sx={{ color: '#000000' }}>
                                                            {row?.tags.find((tag) => tag.key === 'baseline_datasource_version')?.value || 'undefined'}
                                                        </StyledTableCell> */}
                                                                {conditionalModel ? (
                                                                    <>
                                                                        <StyledTableCell>{conditionalProductionActiveColumns()}</StyledTableCell>
                                                                        <StyledTableCell>{conditionalEuclideanActiveColumns()}</StyledTableCell>
                                                                        <StyledTableCell>{conditionalPSIPredictionActiveColumns()}</StyledTableCell>
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                                {driftColumnStatus ? (
                                                                    <StyledTableCell>
                                                                        <a
                                                                            to="/model-drift-images"
                                                                            aria-hidden="true"
                                                                            className="router-link"
                                                                            style={{ color: '005CBC', textDecoration: 'underline', cursor: 'pointer' }}
                                                                            onClick={() => handleShowDriftData(row)}
                                                                        >
                                                                            Details
                                                                        </a>
                                                                    </StyledTableCell>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        )}
                                    </TabPanel>
                                    <TabPanel value="2">
                                        {nonActiveModel.length <= 0 ? (
                                            <Typography variant="body1" style={{ textAlign: 'center', marginTop: '20px' }}>
                                                No Records to display for non-active Model
                                            </Typography>
                                        ) : (
                                            <TableContainer component={Paper}>
                                                <Table>
                                                    <TableHead sx={{ backgroundColor: (theme) => theme.palette.cyan['90'] }}>
                                                        <TableRow>
                                                            {nonActivecolumns.map((column, index) => (
                                                                <StyledTableHeader key={index} maxWidth={column.maxWidth}>
                                                                    {column.name}
                                                                </StyledTableHeader>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {nonActiveModel?.map((row, index1) => (
                                                            <TableRow key={index1}>
                                                                <StyledTableCell sx={{ color: '#3A3A3A', fontWeight: 'normal' }}>
                                                                    <Link
                                                                        to="/pepvigil-model-observability"
                                                                        onClick={() => goToDashboard(row)}
                                                                        style={{ color: '#1378D4' }}
                                                                    >
                                                                        {row.name}
                                                                    </Link>
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>{row?.version}</StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>{row?.current_stage}</StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>
                                                                    {row?.tags.find((tag) => tag.key === 'model_type')?.value || 'undefined'}
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>
                                                                    {row?.tags.find((tag) => tag.key === 'framework')?.value || 'undefined'}
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>
                                                                    {row?.tags.find((tag) => tag.key === 'baseline_datasource_version')?.value || 'undefined'}
                                                                </StyledTableCell>
                                                                {conditionalArchivedModel ? (
                                                                    <>
                                                                        <StyledTableCell>{conditionalNonActiveColumns(row)}</StyledTableCell>
                                                                        <StyledTableCell>{conditionalEuclideanColumn(row)}</StyledTableCell>
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                {nonActiveModel && nonActiveModel.length > 0 ? (
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                                        component="div"
                                                        count={nonActiveModel.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                ) : (
                                                    ''
                                                )}
                                            </TableContainer>
                                        )}
                                    </TabPanel>
                                    <TabPanel value="3">
                                        {newModelData.length <= 0 ? (
                                            <Typography variant="body1" style={{ textAlign: 'center', marginTop: '20px' }}>
                                                No Records to display for new model
                                            </Typography>
                                        ) : (
                                            <TableContainer component={Paper}>
                                                <Table>
                                                    <TableHead sx={{ backgroundColor: (theme) => theme.palette.cyan['90'] }}>
                                                        <TableRow>
                                                            {newModelColumns.map((column, index) => (
                                                                <StyledTableHeader key={index} maxWidth={column.maxWidth}>
                                                                    {column.name}
                                                                </StyledTableHeader>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {newModelData?.map((row, index1) => (
                                                            <TableRow key={index1}>
                                                                <StyledTableCell sx={{ color: '#3A3A3A', fontWeight: 'normal' }}>
                                                                    <Link
                                                                        to="/pepvigil-model-observability"
                                                                        className="router-link"
                                                                        onClick={() => goToDashboard(row)}
                                                                        style={{ color: '005CBC' }}
                                                                    >
                                                                        {row.name}
                                                                    </Link>
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>{row?.version}</StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>{row?.current_stage}</StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>
                                                                    {row?.tags.find((tag) => tag.key === 'model_type')?.value || 'undefined'}
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>
                                                                    {row?.tags.find((tag) => tag.key === 'framework')?.value || 'undefined'}
                                                                </StyledTableCell>
                                                                <StyledTableCell sx={{ color: '#3A3A3A' }}>
                                                                    {row?.tags.find((tag) => tag.key === 'baseline_datasource_version')?.value || 'undefined'}
                                                                </StyledTableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                {newModelData && newModelData.length > 0 ? (
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                                        component="div"
                                                        count={newModelData.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                ) : (
                                                    ''
                                                )}
                                            </TableContainer>
                                        )}
                                    </TabPanel>
                                    <Box sx={componentStyles.container}>
                                        <Box sx={componentStyles.tableContainer}>
                                            <TableComponent driftBaseline={driftBaseline} moduleID={moduleID} />
                                        </Box>
                                        <Box sx={componentStyles.clusterDetails}>
                                            <ClusterDetailsTable clusterId={moduleID} />
                                        </Box>
                                    </Box>
                                </TabContext>
                            </div>
                        </>
                    )}
                </Box>
            </Box>
        </ErrorBoundary>
    );
};

export default DlopsModels;
